import { NativeAdapter } from '@shapeshiftoss/hdwallet-native'
import { KeyStoreIcon } from 'components/Icons/KeyStoreIcon'

export const NativeConfig = {
  adapter: NativeAdapter,
  icon: KeyStoreIcon,
  name: 'Key.Store',
}
